// extracted by mini-css-extract-plugin
export default {"mapContainer":"yandexMap-module__mapContainer__rOdFl","mobileMapContainer":"yandexMap-module__mobileMapContainer__JyfQ6"};